import Autocomplete from '@components/v2/form/Autocomplete/Autocomplete';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../translation/TranslationContext';
import AutoContractGeneration from '../../enums/autoContractGeneration.enum';
import { getAutoContractGenerationLangEnum } from '../../utils/autoContractGeneration.utils';

type AutoContractGenerationAutocompleteProps = {
  value: AutoContractGeneration | null;
  onChange: (value: AutoContractGeneration | null) => void;
  label?: LangEnum;
};

const options = Object.values(AutoContractGeneration);

const AutoContractGenerationAutocomplete = ({
  value,
  onChange,
  label,
}: AutoContractGenerationAutocompleteProps) => {
  const { translate } = useTranslation();

  return (
    <Autocomplete<AutoContractGeneration>
      options={options}
      value={value}
      getOptionLabel={(option) => translate(getAutoContractGenerationLangEnum(option))}
      textFieldProps={{
        label: label
          ? translate(label)
          : translate(LangEnum.GENERAL_SETTINGS_AUTO_CONTRACT_GENERATION_LABEL),
      }}
      onChange={(_, selected) => onChange(selected)}
    />
  );
};

export default AutoContractGenerationAutocomplete;
